(() => {
  const seen = new WeakSet();
  let required = false, confirmed = null, desired = false, confirmedAt = '';
  let pending = 0, version = 0, error = '', queue = Promise.resolve();
  let reminder = false;
  // The checkbox is disabled while its save is pending, which drops keyboard focus to the page.
  // Remember which box had focus and return it once the save finishes.
  let refocusId = '';

  function sydneyTimestamp(date) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Sydney', day: 'numeric', month: 'short', year: 'numeric',
      hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short'
    }).formatToParts(date).map(part => [part.type, part.value]));
    return `${parts.day} ${parts.month} ${parts.year}, ${parts.hour}:${parts.minute}${parts.dayPeriod.toLowerCase()} ${parts.timeZoneName}`;
  }

  function blocked() {
    return pending > 0 || (required && (!confirmed || !!error));
  }

  function paint() {
    document.querySelectorAll('[data-age-confirmation]').forEach(panel => {
      panel.hidden = !required;
      panel.setAttribute('aria-busy', String(pending > 0));
      const input = panel.querySelector('[data-age-confirmation-input]');
      input.checked = desired;
      input.required = required;
      input.disabled = pending > 0;
      const status = panel.querySelector('[data-age-confirmation-status]');
      status.textContent = error || (reminder && required && !desired ? panel.dataset.agePrompt : '');
      status.hidden = !status.textContent;
    });
    document.querySelectorAll('[data-age-checkout]').forEach(button => {
      button.disabled = blocked();
      button.setAttribute('aria-disabled', String(blocked()));
    });
    document.querySelectorAll('[data-age-checkout-target]').forEach(target => {
      target.dataset.ageBlocked = String(blocked());
    });
    document.querySelectorAll('[data-age-accelerated]').forEach(wrapper => {
      wrapper.hidden = blocked();
      wrapper.inert = blocked();
    });
    if (!pending && refocusId) {
      const input = document.getElementById(refocusId);
      refocusId = '';
      if (input && !input.disabled && (!document.activeElement || document.activeElement === document.body)) input.focus();
    }
  }

  function save(checked) {
    if (document.activeElement?.matches?.('[data-age-confirmation-input]')) refocusId = document.activeElement.id;
    reminder = false;
    desired = checked;
    const operation = ++version;
    const stamp = checked ? sydneyTimestamp(new Date()) : '';
    pending++;
    error = '';
    paint();
    queue = queue.catch(() => {}).then(async () => {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Age confirmed': checked ? 'Yes' : '', 'Age confirmed at': stamp } })
      });
      if (!response.ok) throw new Error('Age confirmation save failed');
      const cart = await response.json();
      const attributes = cart.attributes || {};
      if (checked ? attributes['Age confirmed'] !== 'Yes' || attributes['Age confirmed at'] !== stamp
        : !!attributes['Age confirmed'] || !!attributes['Age confirmed at']) throw new Error('Age confirmation was not saved');
      if (operation === version) {
        confirmed = checked;
        confirmedAt = stamp;
      }
    }).catch(() => {
      if (operation === version) error = 'Please try again to save your confirmation.';
    }).finally(() => {
      pending--;
      paint();
    });
    return queue;
  }

  function refresh(cart) {
    document.querySelectorAll('[data-age-confirmation]').forEach(panel => {
      if (seen.has(panel)) return;
      seen.add(panel);
      required = panel.dataset.ageRequired === 'true';
      if (confirmed === null) {
        confirmed = panel.dataset.ageConfirmed === 'true';
        desired = confirmed;
        confirmedAt = panel.dataset.ageConfirmedAt || '';
      }
    });
    if (cart?.item_count === 0) required = false;
    if (!required && (desired || (!pending && (confirmed || confirmedAt)))) save(false);
    paint();
  }

  document.addEventListener('change', event => {
    if (event.target.matches('[data-age-confirmation-input]')) save(event.target.checked);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-age-checkout]')
      || event.target.closest('[data-age-checkout-target]')?.querySelector('[data-age-checkout]');
    if (!button) return;
    refresh();
    if (blocked()) {
      reminder = true;
      paint();
      event.preventDefault();
      event.stopImmediatePropagation();
      document.querySelector('[data-age-confirmation]:not([hidden]) input')?.focus();
    } else if (button.dataset.ageCheckoutUrl) {
      event.preventDefault();
      window.location.assign(button.dataset.ageCheckoutUrl);
    }
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.matches('[data-age-checkout]') && blocked()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function initialise() {
    refresh();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1
        && (node.matches('[data-age-confirmation]') || node.querySelector('[data-age-confirmation]'))))) refresh();
    }).observe(document.body, { childList: true, subtree: true });
  }
  window.TEUAgeConfirmation = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
